import React from 'react';
import {Snackbar } from '@mui/material';
import {Alert} from '@mui/material';

// const useStyles = makeStyles(theme)

const Notification = (props) => {

    const {notify, setNotify} = props;

    const handleClose = (event, reason) => {
        if(reason === 'clickaway') {
            return;
        }
        setNotify({
            ...notify,
            isOpen: false
        })
    }

  return (
    <div>
      <Snackbar
        open={notify.isOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}
      >
        <Alert 
            severity={notify.type}
            onClose={handleClose}>
                {notify.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Notification
